export const convertValueToInteger = (value) => {
  if (!value) return null;
  return parseInt(value, 10);
};

export const sumOfInstallmentsPaid = (payload) => {
  if (!payload) return 0;
  const result = payload
    .filter((item) => item.paymentDate !== null)
    .reduce((acc, curr) => acc + curr.value, 0);

  return result;
};

export const sumOfInstallments = (payload) => {
  if (!payload) return 0;
  const result = payload
    .reduce((acc, curr) => acc + curr.value, 0);

  return result;
};

export const filterUnpaidInstallments = (payload) => {
  if (!payload) return 0;
  const filtered = payload.filter((item) => item.paymentDate === null);
  return filtered;
};

export const mapValueAdjustments = (payload, medValue, insertIndex) => {
  if (!payload) return [];

  const obj = (item, index) => {
    const common = {
      ...item,
      value: medValue,
    };

    return insertIndex ? {
      ...common,
      part: index,
    } : {
      ...common,
    };
  };
  const mappedArray = payload.map((item, index) => {
    if (item.paymentDate === null) {
      return obj(item, index);
    }
    return item;
  });

  return mappedArray;
};
